import React, { useEffect, useState } from "react";
import api from "@/lib/api";
import DashboardShell from "@/components/DashboardShell";
import { Badge } from "@/components/ui/badge";

const STATUS_STYLE = {
  SiteVisitPending: "bg-sg-navy text-white",
  Nurture: "bg-sg-gold/20 text-sg-gold-deep border border-sg-gold/40",
  MidTermFollowUp: "bg-sg-cream-soft text-sg-navy",
  Qualified: "bg-emerald-600 text-white",
  OptedOut: "bg-red-100 text-red-800",
  InProgress: "bg-sg-cream-soft text-sg-mute",
};

export default function Leads() {
  const [leads, setLeads] = useState([]);
  useEffect(() => { api.get("/leads").then(({ data }) => setLeads(data)); }, []);

  return (
    <DashboardShell>
      <div className="overline text-sg-gold-deep">LEAD PIPELINE · WHATSAPP GATEKEEPER</div>
      <h1 className="font-display text-4xl lg:text-5xl text-sg-navy mt-2">
        Qualified <span className="font-serif-italic text-sg-gold-deep">leads.</span>
      </h1>
      <p className="text-sg-mute mt-2 max-w-2xl">
        Every "Inquire" click triggers a 4-step WhatsApp qualification (opt-in → neighborhood → budget → timeline).
      </p>

      <div className="mt-8 bg-white border border-sg-line rounded-3xl overflow-hidden" data-testid="leads-table">
        <div className="hidden md:grid grid-cols-12 gap-3 px-6 py-4 border-b border-sg-line overline text-sg-mute">
          <div className="col-span-2">Status</div>
          <div className="col-span-3">Neighborhood</div>
          <div className="col-span-2">Budget</div>
          <div className="col-span-3">Timeline</div>
          <div className="col-span-2">Created</div>
        </div>
        {leads.length === 0 ? (
          <div className="px-6 py-12 text-sm text-sg-mute text-center">
            No leads yet. Visitors must complete the qualification flow on a listing to appear here.
          </div>
        ) : leads.map((l) => (
          <div key={l.lead_id} className="grid grid-cols-1 md:grid-cols-12 gap-3 px-6 py-5 border-b border-sg-line last:border-0 text-sm items-center" data-testid={`lead-row-${l.lead_id}`}>
            <div className="md:col-span-2">
              <Badge className={`rounded-full ${STATUS_STYLE[l.status] || "bg-sg-cream-soft"}`}>{l.status}</Badge>
              {l.agent_alerted && <span className="ml-2 overline text-sg-gold-deep">· ALERT</span>}
            </div>
            <div className="md:col-span-3 text-sg-navy">{l.neighborhood || "—"}</div>
            <div className="md:col-span-2 font-mono text-sg-navy">{l.budget || "—"}</div>
            <div className="md:col-span-3 text-sg-navy">{l.timeline || "—"}</div>
            <div className="md:col-span-2 text-xs text-sg-mute">{new Date(l.created_at).toLocaleString()}</div>
            {l.auto_reply && (<div className="md:col-span-12 text-xs text-sg-mute italic pl-2">↳ {l.auto_reply}</div>)}
          </div>
        ))}
      </div>
    </DashboardShell>
  );
}
